import React, { useContext, useEffect } from "react";
import { ContextProvider } from "../../App";

import Minus from "../../images/minusIcon.svg";
import Plus from "../../images/plusIcon.svg";

function Items({
  selectionPlan,
  dayItem,
  foodItems,
  selectFoodCategory,
  mondayItem,
  tuesItem,
  wednesdayItem,
  thursdayItem,
  fridayItems,
  selectDailyItem,
  selectDailyFood,
}) { 
 

  const { cartState, cartDispatch } = useContext(ContextProvider);
  console.log(cartState)

  const checkFun = () => {
    if (dayItem === "Monday") {
      return mondayItem;
    } else if (dayItem === "Tuesday") {
      return tuesItem;
    } else if (dayItem === "Wednesday") {
      return wednesdayItem;
    } else if (dayItem === "Thursday") {
      return thursdayItem;
    } else if (dayItem === "Friday") {
      return fridayItems;
    } else {
      return foodItems;
    }
  };
  
  const itemQTY = () => {
    if (dayItem === "Monday" ) {
      return cartState.selectedOrder.monday.qty;
    } else if (dayItem === "Tuesday") {
      return cartState.selectedOrder.tuesday.qty;
    } else if (dayItem === "Wednesday") {
      return cartState.selectedOrder.wednesday.qty;
    } else if (dayItem === "Thursday") {
      return cartState.selectedOrder.thursday.qty;
    } else {
      return cartState.selectedOrder.friday.qty;
    } 
  };


  return (
    <>
      {selectionPlan === "daily" ? (
        <>
          {(selectDailyItem !== "" ? selectDailyItem : foodItems).map(
            (item) => {
              return (
                <div key={item._id}>
                  <div className="food_item_container">
                    <div className="item_text_div">
                      <p>{item.title}</p>
                      {selectDailyItem !== "" && (
                        <div className="inc_dec_btn_box">
                          <span
                            style={{ marginTop: "-0.5rem", cursor: "pointer" }}
                            onClick={() =>
                              cartDispatch({ type: "DECREMENT_QTY" })
                            }
                          >
                            <img src={Minus} alt="minusIcon" />
                          </span>
                          <span>
                            {
                               cartState.menuObj.qty
                            }
                          </span>
                          <span style={{ cursor: "pointer" }}
                          onClick={()=>cartDispatch({ type: "INCREMENT_QTY" }) }
                          >
                            <img src={Plus} alt="plusIcon" />
                          </span>
                        </div>
                      )}
                    </div>
                    <div className="item_img_div">
                      <img
                        src={item.thumbnails}
                        alt="foodImg"
                        onClick={() => selectDailyFood(item._id, item.title)}
                      />
                    </div>
                  </div>
                  <hr className="select_item_line" />
                </div>
              );
            }
          )}
        </>
      ) : (
        <>
          {(checkFun() === "" ? foodItems : checkFun()).map((item) => {
            return (
              <div key={item._id}>
                <div className="food_item_container">
                  <div className="item_text_div">
                    <p>{item.title}</p>
                    {checkFun() !== "" && (
                      <div className="inc_dec_btn_box">
                        {checkFun() === "" ? (
                          <span
                            style={{ marginTop: "-0.5rem", cursor: "pointer" }}
                          >
                            <img src={Minus} alt="minusIcon" />
                          </span>
                        ) : (
                          <span
                            style={{ marginTop: "-0.5rem", cursor: "pointer" }}
                            onClick={() =>
                              cartDispatch({ type: "DECREMENT_QTY", id: item._id })
                            }
                          >
                            <img src={Minus} alt="minusIcon" />
                          </span>
                        )}
                        <span>{itemQTY()}</span>
                        {checkFun() === "" ? (
                          <span style={{ cursor: "pointer" }}>
                            <img src={Plus} alt="plusIcon" />
                          </span>
                        ) : (
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              cartDispatch({ type: "INCREMENT_QTY", id: item._id })
                            }
                          >
                            <img src={Plus} alt="plusIcon" />
                          </span>
                        )}
                      </div>
                    )}
                  </div>
                  <div className="item_img_div">
                    <img
                      src={item.thumbnails}
                      alt="foodImg"
                      onClick={() => selectFoodCategory(item._id, item.title)}
                    />
                  </div>
                </div>
                <hr className="select_item_line" />
              </div>
            );
          })}
        </>
      )}
    </>
  );
}

export default Items;
